/**
 * @readonly
 * @enum {string}
 */
export const AxleLoadEvent = Object.freeze({
    AXLE_LOAD: 'axleLoad',
    SPEED: 'speed',
    TIMESTAMP: 'timestamp'
})
